import { createContext } from 'react';

import type { TSidebarContext } from '../types';

import useNavigationData from '../hooks/useNavigationData';

const defaultContextVal = {
  navConfig: [],
  navConfigError: null,
  navEnabledMap: {},
  navDataLoaded: false,
};

const SidebarContext = createContext<TSidebarContext>(defaultContextVal);

function SidebarProvider({ children }: { children: JSX.Element }) {
  const { navConfig, navConfigError, navDataLoaded, navEnabledMap } = useNavigationData();

  const data = {
    navConfig,
    navConfigError,
    navEnabledMap,
    navDataLoaded,
  };
  return <SidebarContext.Provider value={data}>{children}</SidebarContext.Provider>;
}

export { SidebarContext as Context };
export default SidebarProvider;
